import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import moment from 'moment';

import { ReportFieldEnum } from 'Common/FieldEnum';
import { DropdownObjectCreator } from 'Common/ObjectHelper';
import { newItems } from 'Common/Constants';
import { SelectField, DatePickerField } from 'Common/SemanticWrapper';
import { SiteComponent } from 'Common/SiteComponent';
import { TitledCard } from 'Components';
import { TRANSACTION_HISTORY_FORM_NAME } from 'Common/FormEnum';

class TransactionHistoryForm extends Component {
  render() {
    const { handleSubmit, servedItems } = this.props;

    let items = servedItems
      ? DropdownObjectCreator(servedItems, 'Id', 'ShortDescription', true)
      : [];
    items = [...items, ...newItems];

    return (
      <Form onSubmit={handleSubmit}>
        <TitledCard title={'Report Parameters'}>
          <Grid columns={1} style={{ paddingBottom: '10px' }}>
            <Grid.Row columns={2}>
              <Grid.Column>
                <SiteComponent
                  name={ReportFieldEnum.Site}
                  {...this.props}
                  isForm={true}
                  isPrimary={true}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Item}
                  component={SelectField}
                  type="text"
                  label="ITEM"
                  options={items}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4}>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.FromDate}
                  component={DatePickerField}
                  type="text"
                  label="From"
                  openToDate={moment().add(-1, 'days')}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.ToDate}
                  component={DatePickerField}
                  type="text"
                  label="To"
                  openToDate={moment()}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values[ReportFieldEnum.Site]) {
    errors[ReportFieldEnum.Site] = 'Site is required';
  }
  if (!values[ReportFieldEnum.Item]) {
    errors[ReportFieldEnum.Item] = 'Item is required';
  }
  if (!values[ReportFieldEnum.FromDate]) {
    errors[ReportFieldEnum.FromDate] = 'From date is required';
  }
  if (!values[ReportFieldEnum.ToDate]) {
    errors[ReportFieldEnum.ToDate] = 'To date is required';
  }
  return errors;
};

export default reduxForm({
  validate,
  form: TRANSACTION_HISTORY_FORM_NAME,
  destroyOnUnmount: false,
})(TransactionHistoryForm);



// WEBPACK FOOTER //
// ./src/pages/transactionhistory/components/TransactionHistoryForm.js